<div class="text-box-container">
  <div class="question-header">
    <h6 class="m-0 p-0"
    [style.font-size]="questionnaire?.mainContentTemplate?.questionStyle?.fontSize + 'px'"
    [style.font-family]="questionnaire?.mainContentTemplate?.questionStyle?.fontFamily"
    [style.font-weight]="questionnaire?.mainContentTemplate?.questionStyle?.boldStyle"
    [style.color]="questionnaire?.mainContentTemplate?.questionStyle?.fontColor"
    >
      <!-- {{ questionNumber }}. --> {{ question?.question || 'Untitled Question' | titlecase }}
      @if(question?.required) {
        <span 
        [style.font-size]="'18px'"
        [style.font-family]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontFamily"
        [style.font-weight]="questionnaire?.mainContentTemplate?.errorMessageStyle?.boldStyle"
        [style.color]="questionnaire?.mainContentTemplate?.errorMessageStyle?.fontColor"
        >*</span>
      }
    </h6>
  </div>
  
  <div class="mobile-number-wrapper">
    <div class="mobile-country-code-wrapper">
      <!-- Country Code Selector: not in tab order so tab focuses only the number input -->
      <select
        class="mobile-country-code"
        tabindex="-1"
        [value]="countryCode"
        (change)="onCountryChange($event)"
        [disabled]="disabled">
        @for(c of countries; track c.code) {
          <option [value]="c.dialCode" [selected]="c.dialCode === countryCode">
             {{ c.code }} {{ c.dialCode }}
          </option>
        }
      </select>
      </div>
      
      <!-- Mobile Number Input -->
      <input 
        type="tel"
        class="mobile-number"
        [class.is-invalid]="isInvalid"
        [value]="value"
        (input)="onInputChange($event)"
        (keypress)="allowOnlyNumbers($event)"
        (paste)="allowOnlyPasteNumbers($event)"
        (blur)="onBlur()"
        [disabled]="disabled"
        [placeholder]="placeholder" />

  </div>
</div>
